import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'

interface PageLoaderProps {
  message?: string
}

export default function PageLoader({ message }: PageLoaderProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', py: 12, gap: 2 }}>
      <CircularProgress color="primary" size={48} thickness={3} />
      {message && (
        <Typography variant="body2" sx={{ color: 'text.disabled' }}>
          {message}
        </Typography>
      )}
    </Box>
  )
}
